import { beforeEnterPlanta as beforeEnter } from '@/views/contratos-originacao/planta-fabril/routes/beforeRouter';

const routes = [
    {
        path: '/planta',
        name: 'ConfiguracaoPlanta',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                '@/views/contratos-originacao/planta-fabril/views/ConfiguracaoPlantaFabril.vue'
            )
    },
    {
        path: '/planta/cadastro/:id?',
        name: 'CadastroPlanta',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                '@/views/contratos-originacao/planta-fabril/views/FormularioPlantaFabril.vue'
            )
    },
    {
        path: 'planta/:id',
        name: 'DetalhePlanta',
        meta: {
            roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
        },
        beforeEnter,
        component: () =>
            import(
                '@/views/contratos-originacao/planta-fabril/views/DetalhesPlantaFabril.vue'
            )
    }
];

export default routes;
